import { render, staticRenderFns } from "./configCompetitorOptions.vue?vue&type=template&id=0a6499c0&scoped=true"
import script from "./configCompetitorOptions.vue?vue&type=script&lang=js"
export * from "./configCompetitorOptions.vue?vue&type=script&lang=js"
import style0 from "./configCompetitorOptions.vue?vue&type=style&index=0&id=0a6499c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6499c0",
  null
  
)

export default component.exports